import { callApiToServer } from "../callApi";

export async function deleteCategory(authtoken, categoryId) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let body = JSON.stringify({
      categoryId: categoryId,
    });

    let endUrl = "v1/auth/category/" + categoryId;

    let responseData = await callApiToServer(body, header, "DELETE", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
